import { navigate } from 'gatsby';
import { useEffect } from 'react';

const useDisableDevTools = () => {
    useEffect(() => {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        const handleContextMenu = (e) => {
            if (!isMobile) {
                e.preventDefault();
            }
        };

        const handleKeyDown = (e) => {
            if (
                !isMobile &&
                (e.keyCode === 123 || // F12
                    (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 67)) || // Ctrl + Shift + I, J, C
                    (e.ctrlKey && e.keyCode === 85) || // Ctrl + U
                    (e.metaKey && e.altKey && e.keyCode === 73)) // Cmd + Option + I (Mac)
            ) {
                e.preventDefault();
            }
        };

        const checkDevTools = () => {
            const threshold = 160;

            if (
                !isMobile &&
                (window.outerWidth - window.innerWidth > threshold || window.outerHeight - window.innerHeight > threshold)
            ) {
                navigate('https://www.google.com/');
            }
        };

        const detectDevTools = () => {
            const devToolsOpen = window.outerWidth - window.innerWidth > 160 || window.outerHeight - window.innerHeight > 160;
            if (devToolsOpen) {
                navigate('https://www.google.com/');
            }
        };

        const checkConsole = () => {
            const devToolsCheckInterval = setInterval(() => {
                if (window.console && (console.firebug || console.table && /firebug/i.test(window.console.table))) {
                    navigate('https://www.google.com/');
                }
            }, 500);

            setTimeout(() => clearInterval(devToolsCheckInterval), 5000);
        };

        if (!isMobile) {
            window.addEventListener('contextmenu', handleContextMenu);
            window.addEventListener('keydown', handleKeyDown);
            window.addEventListener('resize', checkDevTools);

            checkDevTools();
            checkConsole();

            const checkInterval = setInterval(detectDevTools, 1000);

            return () => {
                window.removeEventListener('contextmenu', handleContextMenu);
                window.removeEventListener('keydown', handleKeyDown);
                window.removeEventListener('resize', checkDevTools);
                clearInterval(checkInterval);
            };
        }
    }, []);
};

export default useDisableDevTools;
